/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


export const getApiOnboardingProgressResponse = zod.object({
  "steps": zod.array(zod.object({
  "stepName": zod.enum(['BusinessVerificationSubmitted', 'BusinessVerified', 'AstraAuthorized', 'BankAccountLinked', 'AccountFundingInitiated', 'AccountFunded', 'FirstOppCreated', 'TalentInvited', 'FirstPayoutCompleted']),
  "occurredAt": zod.string().datetime({})
}))
})

